import { render, staticRenderFns } from "./NewTratamiento.vue?vue&type=template&id=ca597f2c&scoped=true&"
import script from "./NewTratamiento.vue?vue&type=script&lang=ts&"
export * from "./NewTratamiento.vue?vue&type=script&lang=ts&"
import style0 from "./NewTratamiento.vue?vue&type=style&index=0&id=ca597f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca597f2c",
  null
  
)

export default component.exports